<script setup lang="ts">
import HospitalTimelineService, {TimelineEntryConfig} from "@/hospital/services/HospitalTimelineService";
import {HospitalTimelineEntry} from "@/hospital/interfaces/hospital-timeline";
import HospitalTimelineActivityEntry from "./HospitalTimelineActivityEntry.vue";
import HospitalTimelineMessageEntry from "./HospitalTimelineMessageEntry.vue";

interface Props {
    entry: HospitalTimelineEntry
    config: TimelineEntryConfig
}

defineProps<Props>();
</script>

<template>
  <HospitalTimelineActivityEntry
    v-if="HospitalTimelineService.isActivity(entry)"
    :entry="entry"
    :config="config"
  />
  <HospitalTimelineMessageEntry
    v-else-if="HospitalTimelineService.isHospitalMessage(entry)"
    :entry="entry"
    :config="config"
  />
</template>
